import React from 'react';
interface SectionBadgeProps {
  children: React.ReactNode;
  className?: string;
}

/** Small uppercase pill that opens each section. */
export function SectionBadge({
  children,
  className = ''
}: SectionBadgeProps) {
  return <span className={`inline-flex max-w-full items-center justify-center gap-2 rounded-full bg-terra-soft px-3.5 py-1.5 text-center text-[10px] font-extrabold uppercase leading-snug tracking-[0.12em] text-terra-deep sm:px-4 sm:text-[11px] sm:tracking-[0.18em] ${className}`} data-id="element-14" data-mp="1p48lkegcj2rl">
      {children}
    </span>;
}